import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { apiBaseUrl } from "@config/url.config";

const useSMS = () => {
    const dicte: { [key: string]: string } = {
        0: "старт системы",
        1: 'пробуждение в режиме "трекер"',
        2: 'пробуждение в режиме "периодический"',
        3.1: 'пробуждение в режиме "будильник 1"',
        3.2: 'пробуждение в режиме "будильник 2"',
        3.3: 'пробуждение в режиме "будильник 3"',
        3.4: 'пробуждение в режиме "будильник 4"',
        3.5: 'пробуждение в режиме "будильник 5"',
        3.6: 'пробуждение в режиме "будильник 6"',
        4: "пробуждение по датчику движения",
        5: 'пробуждение "остановка"',
        6.1: "пробуждение по датчику света (появление освещения)",
        6.2: "пробуждение по датчику света (пропадание освещения)",
        10: "координаты определены по LBS",
        11: "координаты определены по спутникам",
    };
    const obj: { [key: string]: string } = {
        e: "Событие",
        x: "Широта",
        y: "Долгота",
        l: "Способ опредления координат",
        t: "Время",
        s: "Скорость, км/ч",
        d: "Направление движения (азимут)",
        a: "Высота над уровнем моря, м",
        sa: "Количество спутников",
        bp: "Заряд батареи, %",
        bv: "Напряжение батареи, В",
        tp: "Температура, С",
        tf: "Время захвата спутников, (мм:cс)",
        sl: "Уровень сигнала GSM",
    };
    const InitialState = {
        longitude: "0",
        latitude: "0",
    };
    const [coord, setCoord] = useState<{ [key: string]: string }>(InitialState);
    const bb = useLocation();
    const str = bb.search;
    const str1 = str
        .replace(
            /lb[\da-fA-F]{3}-[\da-fA-F]{2,3}-[\da-fA-F]{4}-[\da-fA-F]{4}/,
            ""
        )
        .replace(/[=&]lang=ru/g, "");
    let key1 = str1.replace(/[=&]lang=ru/g, "").match(/[a-z]{1,2}/gi);
    let values = str1.match(/\d+\.\d+|\d+/gi);
    let cid: string = "";
    let lat: string = "";
    let lon: string = "";
    let yandexPosition = false;
    let arr: any = {};

    let res = str.match(
        /[\da-fA-F]{3}-[\da-fA-F]{2,3}-[\da-fA-F]{4}-[\da-fA-F]{4}/
    );
    if (res) {
        cid = res[0];
    }

    async function yandexAPI(data: string) {
        try {
            const resp = await fetch(`${apiBaseUrl}/sms/fetch`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify([data]),
            });
            const json = await resp.json();
            return json;
        } catch (e) {
            throw new Error(e);
        }
    }

    for (var i = 0; i < (key1?.length ?? 0); i++) {
        if (key1?.[i] == key1?.[i].toUpperCase()) {
            key1?.splice(i, 1);
            i--;
        }
        if (key1?.[i] == "lb") {
            key1?.splice(i, 1);
            i--;
        }
    }

    for (let i = 0; i < (key1?.length ?? 0); i++) {
        if (key1?.[i] === "t") {
            let resdata = "";
            let restime = "";
            let datatime = values?.[i] ?? "";
            let datastamp = datatime?.slice(0, 6) ?? "";
            let timestamp = datatime?.slice(6, 12) ?? "";
            for (let ii = 0; ii < (timestamp?.length ?? 0); ii += 2) {
                resdata += datastamp?.[ii] + (datastamp?.[ii + 1] ?? "") + "/";
                restime += timestamp?.[ii] + (timestamp?.[ii + 1] ?? "") + ":";
            }
            arr[key1?.[i] ?? ""] =
                resdata.slice(0, -1) + " " + restime.slice(0, -1);
        } else if (key1?.[i] === "e") {
            let bb = dicte?.[values?.[i] ?? ""];
            arr[key1?.[i]] = bb;
        } else if (key1?.[i] === "tp") {
            if (str[str.indexOf("tp") + 2] === "-") {
                arr[key1?.[i]] = "-" + values?.[i];
            } else {
                arr[key1?.[i]] = values?.[i];
            }
        } else if (key1?.[i] === "bv") {
            arr[key1?.[i]] = values?.[i];
        } else if (key1?.[i] === "bp") {
            arr[key1?.[i]] = values?.[i];
        } else if (key1?.[i] === "l") {
            let date = str.slice(str.indexOf("l") + 1, str.indexOf("l") + 2);
            if (date === "1") {
                arr[key1[i]] = "координаты определены по спутникам";

                arr["x"] = values?.[key1.indexOf("x")];
                arr["y"] = values?.[key1.indexOf("y")];
                if (arr["x"] === undefined) {
                    yandexPosition = true;
                }
                lon = arr["y"];
                lat = arr["x"];
            } else {
                arr[key1[i]] = "координаты определены по LBS";
                yandexPosition = true;
            }
        } else if (key1?.[i] === "lb") {
            let ref =
                /[\da-fA-F]{3}-[\da-fA-F]{2,3}-[\da-fA-F]{4}-[\da-fA-F]{4}/;
            arr[key1?.[i]] = str.slice(str.indexOf("lb") + 2);
            cid = str.slice(str.indexOf("lb") + 2, str.indexOf("lb") + 18);
            delete arr["lb"];
        } else if (key1?.[i] === "tf") {
            let minutes: string | number = Math.floor(Number(values?.[i]) / 60);
            let extraSeconds: string | number = Number(values?.[i]) % 60;
            minutes = minutes < 10 ? "0" + minutes : minutes;
            extraSeconds =
                extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
            arr[key1?.[i]] = minutes + ":" + extraSeconds;
        } else if (key1?.[i] === "sl") {
            if (Number(values?.[i]) <= 8) {
                arr[key1?.[i]] = "плохой";
            } else if (Number(values?.[i]) > 8 && Number(values?.[i]) <= 16) {
                arr[key1?.[i]] = "удовлетворительный";
            } else if (Number(values?.[i]) > 16 && Number(values?.[i]) <= 24) {
                arr[key1?.[i]] = "хороший";
            } else if (Number(values?.[i]) > 24) {
                arr[key1?.[i]] = "отличный";
            }
        } else {
            if (!!obj[key1?.[i] ?? ""]) {
                arr[key1?.[i] ?? ""] = values?.[i];
            }
        }
        lon = arr["y"];
        lat = arr["x"];
    }

    useEffect(() => {
        if (yandexPosition) {
            fetchCoord();
        } else {
            setCoord({
                longitude: lon,
                latitude: lat,
            });
        }

        async function fetchCoord() {
            try {
                let bb = await yandexAPI(cid);
                setCoord(bb);
            } catch (error) {
                console.error(error);
            }
        }
    }, []);

    return {
        arr,
        obj,
        coord,
    };
};

export default useSMS;
